/* eslint-disable jsx-a11y/label-has-for */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { PureComponent } from 'react'
import { Form, Input } from 'semantic-ui-react'

export default class MaxPayableField extends PureComponent {
  render() {
    const { value, onChange } = this.props

    return (
      <Form.Field required>
        <label>Max Payable Amount</label>
        <Input
          label={{ content: '$' }}
          labelPosition="right"
          placeholder="e.g 20"
          type="number"
          min="0"
          max="50"
          required
          onChange={e => onChange('max_payable_amount', e.target.value)}
          value={value}
        />
      </Form.Field>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/drivers/fields/maxPayableField.js